import React, { useState } from "react";
import { Box, styled, Button, Dialog, Typography, useMediaQuery } from "@mui/material";

import StatusIcon from "../../../iconography/StatusIcon";

const CustomDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: theme.shape.radii.lg,
    width: "100%",
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "500px !important",
  },
  "& .MuiDialog-container": {
    height: "100vh",
    width: "100vw",
    position: "fixed",
    top: "0",
    left: "0",
    display: "block",
  },
}));

function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  description,
  confirmLabel,
  cancelLabel = "Cancelar",
  iconColor,
  icon,
  confirmIcon,
  cancelIcon,
}) {
  const isSmallScreen = useMediaQuery("(max-width: 600px)");
  const [isConfirming, setIsConfirming] = useState(false);

  const closeModal = () => {
    onClose?.(false);
  };

  const handleClose = () => {
    closeModal();
  };

  const handleConfirm = async () => {
    if (!onConfirm || isConfirming) return;

    setIsConfirming(true);

    try {
      await onConfirm();
    } finally {
      setIsConfirming(false);
    }
  };

  return (
    <CustomDialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={false}
    >
      <Box
        p={isSmallScreen ? 5 : 6.25}
        pt={isSmallScreen ? 8.125 : 9.375}
        sx={{ textAlign: "center", backgroundColor: "background.paper" }}
      >
        <Box
          display={"flex"}
          sx={{ justifyContent: "center", mb: 1.25, gap: 1.25 }}
        >
          <StatusIcon
            color={iconColor}
            status={icon}
            width={isSmallScreen ? "65px" : "85px"}
            height={isSmallScreen ? "65px" : "85px"}
          />
        </Box>

        <Box
          display={"flex"}
          sx={{
            flexDirection: "column",
            gap: 1.25,
            mb: 2.5,
            mt: 2.5,
          }}
        >
          <Typography
            sx={(theme) => ({
              color: theme.palette.custom.purple[600],
              fontSize: isSmallScreen ? "20px" : "24px",
            })}
          >
            {title}
          </Typography>

          <Typography sx={{ color: "text.secondary", fontSize: "16px" }}>
            {description}
          </Typography>
        </Box>

        <Box display={"flex"} sx={{ flexDirection: "column", gap: 0.625 }}>
          <Button
            sx={(theme) => ({
              backgroundColor: "transparent",
              border: `2px solid ${theme.palette.custom.purple[400]}`,
              color: theme.palette.custom.purple[500],
              py: 1.5,
              px: 2.5,
              borderRadius: theme.shape.radii.sm,
              width: "100%",
            })}
            onClick={closeModal}
            startIcon={cancelIcon}
          >
            {cancelLabel}
          </Button>
          {confirmLabel && (
            <Button
              variant="contained"
              disabled={isConfirming || !onConfirm}
              onClick={handleConfirm}
              startIcon={confirmIcon}
              sx={(theme) => ({
                backgroundColor: theme.palette.custom.purple[500],
                color: "primary.contrastText",
                py: 1.5,
                px: 2.5,
                borderRadius: theme.shape.radii.sm,
                border: "none",
                width: "100%",
                "&:hover": {
                  backgroundColor: theme.palette.custom.purple[400],
                },
              })}
            >
              {confirmLabel}
            </Button>
          )}
        </Box>
      </Box>
    </CustomDialog>
  );
}

export default ConfirmDialog;
